/**
 * Inverse mapping of a key to its index in an array.
 *
 * @public
 */
var KeyIndexImpl = /** @class */ (function () {
    function KeyIndexImpl(keys) {
        this.keys = keys;
        /* tslint:disable-next-line */
        this.index = Object.create(null);
        this.size = keys.length;
        this.last = this.size - 1;
        var i = 0;
        while (i < keys.length) {
            this.index[keys[i]] = i;
            i++;
        }
    }
    KeyIndexImpl.prototype.get = function (key) {
        var i = this.index[key];
        return i === undefined ? -1 : i;
    };
    return KeyIndexImpl;
}());
export { KeyIndexImpl };
var NULL_KEYINDEX = new KeyIndexImpl([]);
var WARNED = {};
/**
 * @public
 */
var OriginImpl = /** @class */ (function () {
    function OriginImpl(block, indices) {
        this.block = block;
        this.indices = indices;
        this.type = 'origin';
    }
    OriginImpl.prototype.getIndex = function (name) {
        var r = this.indices[name];
        if (r === undefined) {
            /* istanbul ignore next */
            if (!WARNED[name]) {
                // NOTE: Unless something went horribly wrong, this should only occur during development.
                console.log("Error: failed to locate index/value set named \"" + name + "\"");
                WARNED[name] = true;
            }
            return NULL_KEYINDEX;
        }
        return r;
    };
    OriginImpl.prototype.getValues = function (name) {
        return this.getIndex(name).keys;
    };
    return OriginImpl;
}());
export { OriginImpl };
/**
 * @internal
 */
export var digits = function (name, dim0, values) { return ({
    type: 'digits',
    name: name,
    dim0: dim0,
    values: values,
}); };
/**
 * @internal
 */
export var field = function (name) { return ({ type: 'field', name: name }); };
/**
 * @internal
 */
export var origin = function (block, indices) {
    return new OriginImpl(block, indices);
};
/**
 * @internal
 */
export var scope = function (name, identifier, block) { return ({
    type: 'scope',
    name: name,
    identifier: identifier,
    block: block,
}); };
/**
 * @internal
 */
export var scopemap = function (name, fields, block) { return ({
    type: 'scopemap',
    name: name,
    fields: fields,
    block: block,
}); };
/**
 * @internal
 */
export var vector = function (name, dims) { return ({ type: 'vector', name: name, dims: dims }); };
//# sourceMappingURL=instructions.js.map